export type FormFields = {
    openAIProperties: OpenAIPropertiesFields;
    advancedSettings: AdvancedSettingsFields;
    promts: PromtsFields;
    actions: {
        callingClassificationInstruction: string;
    }
}

export enum SectionName {
    OpenAIProperties = 'openAIProperties',
    AdvancedSettings = 'advancedSettings',
    Promts = 'promts'
}

export type OpenAIPropertiesFields = {
    enabled: boolean;
    apiKey: string;
}

export type AdvancedSettingsFields = {
    historyLimit?: number;
    chatCompletionParams: {
        model: string;
        temperature?: number;
        max_tokens?: number;
        top_p?: number;
        frequency_penalty?: number;
        presence_penalty?: number;
    }
}

export type PromtsFields = {
    knowledgeBase: string;
    botInstruction: string;
    suggestionInstruction: string;
}